import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { WebhookService } from 'src/app/service/webhook.service';
import { RequestService } from 'src/app/service/request.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-single-webhook',
  templateUrl: './single-webhook.component.html',
  styleUrls: ['./single-webhook.component.scss'],
  providers: [MessageService],
})
export class SingleWebhookComponent {
  userId: string = '';
  webhooks: any = {};
  requests: any = {};
  singleWebhook: any = {};
  individualRequest: any = {};
  singleRequest: any = {};
  isModalOpen: boolean = false;
  isModalOpen2: boolean = false;
  duration: string = '';
  modalTitle = 'Update Webhook Configuration';
  modalTitle2 = 'Request Details';
  updatedError: string[] = [''];
  isLoading: boolean = false;
  data: any;
  fromDate: any;
  searchRequest: string = '';
  toDate: any;
  responseState: string = '';
  method: string = '';
  limit: number = 25;
  page: number = 1;
  totalList: number = 0;
  fetchingData: boolean = false;

  tableHeaders: string[] = [
    'Name',
    'Type',
    'Resend',
    'Resend Duration',
    'URL',
    'Status',
    'Trials',
    'Created At',
  ];
  tableData: any[] = [];

  formModal = {
    webhookConfigId: '',
    name: '',
    type: '',
    webhookUrl: '',
    resend: '',
    resendDuration: 0,
    acceptableError: '',
    senderUrl: '',
  };

  newFormModal = {
    webhookConfigId: '',
    name: '',
    type: '',
    webhookUrl: '',
    resend: false,
    resendDuration: 0,
    acceptableError: [''],
    senderUrl: '',
  };

  typeOptions = [
    { value: 'Sending', label: 'Sending' },
    { value: 'Receiving', label: 'Receiving' },
  ];

  timeOptions = [
    { value: '1', label: '1 second' },
    { value: '2', label: '2 second' },
    { value: '3', label: '3 second' },
    { value: '4', label: '4 second' },
    { value: '5', label: '5 second' },
  ];

  resendOptions = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ];

  constructor(
    private webhookService: WebhookService,
    private route: ActivatedRoute,
    private location: Location,
    private requestService: RequestService,
    private messageService: MessageService
  ) {
    // console.log('1');
    this.userId = this.route.snapshot.params['id'];
    // console.log(this.userId)
    // console.log('2');
    this.userId = this.location.path().slice(10);
    // console.log(this.userId);

    this.fromDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.toDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
    this.data = [
      {
        type: 'search',
        name: 'Search',
        label: 'Search by Id',
        value: '',
        defaultValue: '',
        placeHolder: 'search...',
      },
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromDateValue: '',
        toDateValue: '',
      },
      {
        type: 'select',
        name: 'status',
        label: 'Status',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'completed', value: 'Completed' },
          { key: 'incomplete', value: 'Incomplete' },
        ],
      },
      {
        type: 'select',
        name: 'method',
        label: 'Method',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'POST', value: 'POST' },
          { key: 'GET', value: 'GET' },
        ],
      },
      {
        type: 'input',
        name: 'responseState',
        label: 'ResponseState',
        value: '',
        defaultValue: '',
        placeHolder: '200',
      },
    ];
  }
  ngOnInit() {
    // console.log(this.userId);
    this.getWebhooks();
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  onFilterChanged(value: any) {
    // console.log(value);
    this.searchRequest = value[0].value;
    this.fromDate = value[1].fromDateValue;
    this.toDate = value[1].toDateValue;
    this.method = value[2].value;
    this.responseState = value[3].value;
    // console.log(this.fromDate);
    // console.log(this.fromDate);
    this.getRequests();
  }
  closeModal = () => {
    this.isModalOpen = false;
  };
  closeModal2 = () => {
    this.isModalOpen2 = false;
  };
  requestDetails = () => {
    this.isModalOpen2 = true;
  };

  async getWebhooks() {
    // this.fetchingData = true;
    (await this.webhookService.getWebhooks()).subscribe({
      next: (res: any) => {
        this.webhooks = res.data;
        // if (this.webhooks.length > 0) {
        //   for (let i = 0; i < this.webhooks.length; i++) {
        //   }
        //   this.tableData = this.webhooks?.map((i: any, n: number) => {
        //     return [
        //       i._id,
        //       i.name,
        //       i.type,
        //       i.resend,
        //       i.resendDuration,
        //       i.acceptableError,
        //     ];
        //   });
        // }
        this.singleWebhook = this.webhooks.find(
          (obj: { _id: string | number }) => obj._id === this.userId
        );
        this.getRequests();
        // console.log(this.singleWebhook);
        error: (error: any) => {
          // this.fetchingData = false;
        };
      },
    });
  }
  refreshRequests() {
    this.page = 1;
    this.getRequests();
  }

  getRequests() {
    this.fetchingData = true;

    this.requestService
      .getRequests(
        this.page - 1,
        this.limit,
        this.fromDate,
        this.toDate,
        this.responseState,
        this.method,
        this.searchRequest,
        this.singleWebhook._id
      )
      .subscribe({
        next: (res: any) => {
          this.fetchingData = false;
          this.requests = res.data;
          this.totalList = res.totalNum;
          // console.log(this.totalList)
          // if (this.webhooks.length > 0) {
          //   for (let i = 0; i < this.webhooks.length; i++) {
          //   }
          //   this.tableData = this.webhooks?.map((i: any, n: number) => {
          //     return [
          //       i._id,
          //       i.name,
          //       i.type,
          //       i.resend,
          //       i.resendDuration,
          //       i.acceptableError,
          //     ];
          //   });
          // }
          if (this.requests.length > 0) {
            this.individualRequest = this.requests.find(
              (obj: { webhookConfig: { _id: string } }) =>
                obj.webhookConfig._id === this.userId
            );
          }
          if (this.requests.length > 0) {
            this.singleRequest = this.requests.filter(
              (obj: { webhookConfig: { _id: string } }) =>
                obj.webhookConfig._id === this.userId
            );
          }
          // console.log(this.singleRequest);
          this.totalList = this.singleRequest.length;
          // console.log(this.totalList)
          if (this.singleRequest.length > 0) {
            for (let i = 0; i < this.singleRequest.length; i++) {}
            this.tableData = this.singleRequest?.map((i: any, n: number) => {
              return [
                i._id,
                i.webhookConfig.name,
                i.webhookConfig.type,
                i.webhookConfig.resend,
                i.webhookConfig.resendDuration,
                i.url,
                i.responseStatus,
                i.trials,
                i.createdAt,
              ];
            });
          } else {
            this.tableData = [];
            this.fetchingData = false;
          }
          error: (error: any) => {
            this.fetchingData = false;
          };
        },
      });
  }

  updateWebhook = () => {
    this.isModalOpen = true;
    this.singleWebhook = this.webhooks.find(
      (obj: { _id: string | number }) => obj._id === this.userId
    );
    this.formModal.webhookConfigId = this.singleWebhook._id;
    this.formModal.senderUrl = this.singleWebhook.senderUrl;
    this.formModal.name = this.singleWebhook.name;
    this.formModal.type = this.singleWebhook.type;
    this.formModal.webhookUrl = this.singleWebhook.webhookUrl;
    this.formModal.resend = this.singleWebhook.resend;
    this.formModal.resendDuration = this.singleWebhook.resendDuration;
    this.formModal.acceptableError =
      this.singleWebhook.acceptableError.join(',');
    // this.formModal.acceptableError = this.updatedError.map((ip: string) => {
    //   return ip.trim();
    // })
  };

  onUpdatedName(data: string) {
    this.newFormModal.name = data;
    // console.log(this.formModal)
  }

  onUpdatedType(data: string) {
    this.newFormModal.type = data;
  }

  onUpdatedUrl(data: string) {
    this.newFormModal.webhookUrl = data;
    // console.log(this.formModal)
  }

  onUpdatedError(data: string) {
    this.newFormModal.acceptableError = data.split(',');
    this.newFormModal.acceptableError = this.newFormModal.acceptableError.map(
      (ip: string) => {
        return ip.trim();
      }
    );
    // console.log(this.formModal)
  }

  onUpdatedResend(data: string) {
    if (data == 'true') {
      this.newFormModal.resend === true;
    } else {
      this.newFormModal.resend === false;
    }
  }

  onUpdatedResendDuration(data: string) {
    this.duration = data;
  }

  patchWebhook = () => {
    this.isLoading = true;
    this.newFormModal.webhookConfigId = this.formModal.webhookConfigId;
    // console.log(this.newFormModal);
    this.newFormModal.resendDuration = parseInt(this.duration, 10);
    this.webhookService
      .updateWebhook(this.newFormModal)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Updated Successfully',
            detail: 'Configuration Updated Successfully',
          });
          this.getWebhooks();
          // console.log('Webhook Config Updated Successfully');
          this.isModalOpen = false;
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        } else {
          this.isLoading = false;
          // console.log('Problem updating Webhook Configuration');
        }
      });
  };
}

// eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2FnZSI6IkFQSS1LRVkiLCJhcGlLZXkiOiI2NTlmZGJkNjc1MDQxY2U0NjJkNjQ5M2MiLCJ1c2VySUQiOiI2NTc2ZDk1MzA5ZmZiN2EyYWNlODM3ZmIiLCJpYXQiOjE3MDQ5NzUzMTgsImV4cCI6MTczNjUzMjkxOH0.loK5qQUVanoiXpZFFYPRId8kl3-UpvTLRnbiWoSA6QU
